import { BehaviorSubject, Observable, map } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';

import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncodeDecodeService implements OnInit {
  tokenFromUI: any = "0123456789123456";
  dynamicKey: string = "";
  encrypted: any = "";
  decrypted: any | string;

  constructor(public http: HttpClient) {
  }
  ngOnInit(): void {
  }

  encryptionFunction(key: any, value: any): any {
    const iv = CryptoJS.enc.Utf8.parse(key);
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
    const valueUtf8 = CryptoJS.enc.Utf8.parse(JSON.stringify(value));
    const encrypted = CryptoJS.AES.encrypt(
      valueUtf8,
      keyUtf8,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CTR,
        padding: CryptoJS.pad.NoPadding
      }
    );
    this.encrypted = encrypted.toString();
    return this.encrypted;
  }

  decryptFunction(key: any, value: any): any {
    const iv = CryptoJS.enc.Utf8.parse(key);
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
    const decrypted = CryptoJS.AES.decrypt(
      value,
      keyUtf8,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CTR,
        padding: CryptoJS.pad.NoPadding
      }
    );
    const utf8Decrypted = CryptoJS.enc.Utf8.stringify(decrypted);
    this.decrypted = utf8Decrypted;
    return this.decrypted;
  }

  encryptFunctionDynamic(value: string): string {
    const encodedWord = CryptoJS.enc.Utf8.parse(value);
    const encoded = CryptoJS.enc.Base64.stringify(encodedWord);
    return encoded;
  }

  generateReverseEncryptData(data: string): string {
    const reverseResult = data.split('').reverse().join('');
    return this.encryptFunctionDynamic(reverseResult);
  }

  decodeAndReverse(value: string): string {
    const decoded = atob(value);
    const reversed = decoded.split('').reverse().join('');
    return reversed;
  }


}
